// Only these locales are built for the main site: English (navbar default),
// the navbar language switcher locales (zh, ja, es, ko).
// All other locale/alias paths are dropped and are redirected to
// www.tdcx.com at the Cloudflare level instead of being generated here.
const allLocales = {
  en: {
    default: true,
    path: "en",
    locale: "en",
    htmlLang: "en",
    hrefLang: "x-default",
  },
  zh: {
    path: "zh",
    locale: "zh",
    htmlLang: "zh",
    alias: ["zh"],
    hrefLang: "zh",
  },
  ja: {
    path: "ja",
    locale: "ja",
    htmlLang: "ja",
    alias: ["ja"],
    hrefLang: "ja",
  },
  es: {
    path: "es",
    locale: "es",
    htmlLang: "es",
    alias: ["es"],
    hrefLang: "es",
  },
  ko: {
    path: "ko",
    locale: "ko",
    htmlLang: "ko",
    alias: ["ko"],
    hrefLang: "ko",
  },
};

const stagingLocale = {
  en: {
    default: true,
    path: "en",
    locale: "en",
    htmlLang: "en",
    hrefLang: "x-default",
  },
  zh: {
    path: "zh",
    locale: "zh",
    htmlLang: "zh",
    alias: ["zh"],
    hrefLang: "zh",
  },
  ja: {
    path: "ja",
    locale: "ja",
    htmlLang: "ja",
    alias: ["ja"],
    hrefLang: "ja",
  },
  es: {
    path: "es",
    locale: "es",
    htmlLang: "es",
    alias: ["es"],
    hrefLang: "es",
  },
  ko: {
    path: "ko",
    locale: "ko",
    htmlLang: "ko",
    alias: ["ko"],
    hrefLang: "ko",
  },
};

// For tdcx.cn
const chineseOnly = {
  zh: {
    default: true,
    path: "zh",
    locale: "zh",
    htmlLang: "zh",
    hrefLang: "zh",
  },
};

module.exports =
  process.env.GATSBY_ACTIVE_ENV === "production"
    ? process.env.GATSBY_BUILD_SITE === "china"
      ? chineseOnly // Generate Chinese only!
      : allLocales // Generate allLocales only!
    : process.env.GATSBY_BUILD_SITE === "china"
      ? chineseOnly // Generate Chinese only!
      : stagingLocale; // Generate staging locales
